module.exports = __webpack_public_path__ + "static/media/hamburger.7815bb70.png";